import Common from "~/js/common/common";
import store from "~/js/store/store";
import Header from "~/js/common/header";
import Footer from "~/js/common/footer";
import Modal from "~/js/common/modal";
import CardName from "./cardName";
import HeaderMenu from "./headerMenu";
import SortStoreItems from "./sortStoreItems";
import Selector from "./selector";
import Stickypin from "~/js/common/stickypin";
import Favorite from "~/js/ec/favorite";
import Tooltip from "~/js/common/tooltip";
import _each from "lodash/each";
export default class CartMain {
  constructor() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "beforeScroll") {
      } else if (mutation.type === "init") {
        this.init();
      } else if (mutation.type === "closeModal") {
        this.hidePointError();
      }
    });

    if (
      navigator.userAgent.indexOf("iPhone") > 0 ||
      navigator.userAgent.indexOf("iPod") > 0 ||
      navigator.userAgent.indexOf("iPad") > 0 ||
      navigator.userAgent.indexOf("Android") > 0 ||
      (/android|ipod|ipad|iphone|macintosh/.test(navigator.userAgent.toLowerCase()) && "ontouchend" in document)
    ) {
      store.dispatch("setIsSP", {
        sta: true
      });
    }

    this.header = new Header();
    this.footer = new Footer();
    this.favorite = new Favorite(document.querySelector(".cart__items"));
    this.modal = new Modal();
    this.headerMenu = new HeaderMenu();
    this.selector = new Selector();
    this.stickyPin = new Stickypin();
    this.tooltip = new Tooltip();
    store.dispatch("init");

    this.setupCheckbox();
    // this.setupGift();
    // this.blurPoint();
    // this.setupPoint();
    // this.initPoint();// wl20230302
  }

  init() {
    window.scrollTo(0, 0);
    Common.init();
    Common.setupScrollY();
  }

  // チェックボックスの設定
  setupCheckbox() {
    // TODO: 要素がない際にエラーになってしまう部分の修正
    const pointsCheck = document.querySelector(".js-cart-modal-point");
    const giftCheck = document.querySelector(".js-cart-modal-gift");
    if (pointsCheck) {
      pointsCheck.addEventListener("change", (event) => {
        event.preventDefault();

        if (!pointsCheck.checked && pointsCheck.classList.contains('using-point')) {
          pointsCheck.checked = true;
          return false;
        }

        if (pointsCheck.checked) {
          store.dispatch("openModal", {
            name: "cart-point"
          });
          pointsCheck.checked = false;
        } else {
          this.reflectionPoint(0);
          this.reflectionPrice(0);
        }
        ISSEYMIYAKE.Cart.init()
      });
    }
    
    if (giftCheck) {
      giftCheck.addEventListener("change", (event) => {
        event.preventDefault();
        if (giftCheck.checked) {
          store.dispatch("openModal", {
            name: "cart-gift"
          });
          giftCheck.checked = false;
        }
      });
    }
  }

  // ギフトラッピング利用の設定
  setupGift() {
    const useGiftButton = document.querySelector(".js-usegiftbutton");
    const closeButton = document.querySelector(".js-giftmodal-close")
    if (useGiftButton) {
      useGiftButton.addEventListener("click", (e) => {
        const giftSelect = document.querySelector(".js-giftselect");
        const useGift = giftSelect.value;
        this.reflectGift(useGift);
        store.dispatch("closeModal", {
          reason: "enable"
        });
      });
    }
    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault()
        this.reflectGift(0)
        store.dispatch("closeModal")
      })
    }
  }

  // ポイント入力欄からフォーカスが離れた時の処理
  blurPoint() {
    let usePointInput = document.querySelector(".js-usepoint");
    if (usePointInput) {
      usePointInput.addEventListener("blur", () => {
        const inputNum = Math.floor(usePointInput.value / 100) * 100;
        const maxNum = Number(usePointInput.max);

        usePointInput.value = inputNum > maxNum ? maxNum : inputNum;
      });
    }
  }

  // wl20230302
  initPoint() {
    const usePointInput = document.getElementById('_useing_point')
    const usePoint = usePointInput.value;
    if (!this.checkUsePoint(parseInt(usePoint, 10))) {
      this.showPointError();
      return;
    }

    if (usePoint > 0) {
      this.reflectionPoint(usePoint || 0);
      this.reflectionPrice(usePoint || 0);
      const pointsCheck = document.querySelector(".js-cart-modal-point");
      pointsCheck.checked = true;
    }
    ISSEYMIYAKE.Cart.init()
  }

  // ポイント利用の設定
  setupPoint() {
    let usePointButton = document.querySelector(".js-usepointbutton");
    const closeButton = document.querySelector(".js-pointmodal-close")
    if (usePointButton) {
      usePointButton.addEventListener("click", (e) => {
        const usePointInput = document.querySelector(".js-usepoint");
        e.preventDefault();
        const usePoint = usePointInput.value;
        if (!this.checkUsePoint(parseInt(usePoint, 10))) {
          this.showPointError();
          return;
        }

        if (usePoint > 0) {
          this.reflectionPoint(usePoint || 0);
          this.reflectionPrice(usePoint || 0);
          const pointsCheck = document.querySelector(".js-cart-modal-point");
          pointsCheck.checked = true;
        }
        store.dispatch("closeModal", {
          reason: "enable"
        });
        ISSEYMIYAKE.Cart.init()
      });
    }
    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault()
        this.reflectionPoint(0);
        this.reflectionPrice(0);
        store.dispatch("closeModal")
      })
    }
  }

  // ギフトラッピング使用の反映
  reflectGift(useGift) {
    const giftCheck = document.querySelector(".js-cart-modal-gift");
    if (parseInt(useGift, 10) === 0) {
      giftCheck.checked = false;
    }else{
      giftCheck.checked = true;
    }
  }

  // 使用ポイントの数字を反映
  reflectionPoint(usePoint) {
    const pointtexts = document.querySelectorAll(".js-usepoint-text");
    _each(pointtexts, (pointtext) => {
      if (usePoint) {
        pointtext.classList.add("type-attention");
        pointtext.innerText = "-" + Common.addComma(usePoint);
      } else {
        pointtext.classList.remove("type-attention");
        pointtext.innerText = usePoint;
        const check = document.querySelector(".js-cart-modal-point");
        check.checked = false;
      }
      pointtext.setAttribute("data-value", usePoint);
    });
  }
  reflectionPrice(usePoint) {
    const totalPriceDom = document.querySelector(".js-totalprice");
    if (totalPriceDom) {
      const totalPrice = totalPriceDom.getAttribute("data-value");
      totalPriceDom.setAttribute("data-comuted-value", totalPrice - usePoint);
      /**
       * developer: kanehori
       * 価格に円をつける + 3桁区切りに変更
       * Before:
       * totalPriceDom.innerText = Common.addComma(totalPrice - usePoint);
       */
      totalPriceDom.innerText = Common.addComma(totalPrice - usePoint).toLocaleString() + ' 円';
    }
  }

  // 使用可能なポイント数かどうかのチェック
  checkUsePoint(point) {
    const usablePointDom = document.querySelector(".js-usablepoint");
    const totalPriceDom = document.querySelector(".js-totalprice");
    if (usablePointDom) {
      const usablePoint = usablePointDom.getAttribute("data-value");
      if (point > parseInt(usablePoint, 10)) {
        return false;
      }
    } else {
      return false;
    }
    if (totalPriceDom) {
      const totalPrice = totalPriceDom.getAttribute("data-value");
      if (point > parseInt(totalPrice, 10)) {
        return false;
      }
    } else {
      return false;
    }
    return true;
  }

  // ポイントに関するエラー表示
  showPointError() {
    const _dom = document.querySelector(".js-pointerror");
    if (_dom) {
      _dom.classList.add("appear");
    }
  }
  hidePointError() {
    const _dom = document.querySelector(".js-pointerror");
    if (_dom) {
      _dom.classList.remove("appear");
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new CartMain();
});
